import React from "react"
import header from "../../assets/images/header.png"

function EventHeader() {
    return (
        <div className="event-header">
            <img src={header} alt="Event Header" />
        </div>
    )
}

export default EventHeader
